export enum ActionTypes {
    INITIAL = 'INITIAL',
    SUCCEED = 'succeed',
    FAILED = 'failed',
    PENDING = 'pending',
}
